<template>
  <page>
    <sidebar slot="sidebar"/>
    <span slot="header">Knowledge Check Reporting</span>
    <b-tabs card no-fade>
      <b-tab title="Completed" active>
        <completed/>
      </b-tab>
      <!-- <b-tab title="<i class='fas fa-plus'></i> Progress">
        <h2>Progress</h2>
        <p>show a matrix with all the users on the y and kc's on the x with a
        red/green (x/o) in the square if the user has passed the kc
        </p>
      </b-tab> -->
    </b-tabs>
  </page>
</template>

<script>

import { mapState } from 'vuex'
import page from '@/components/templates/page'
import sidebar from '@/components/sidebar'
import completed from './completed'

export default {
  components: {
    completed,
    page,
    sidebar
  },
  data() {
    return {
    }
  },
  computed: {
    ...mapState('tenants', {
      organization: 'current'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/admin/knowledge-checks/reports/index.vue